module.exports = __webpack_public_path__ + "static/media/arrow-up.083fbf42.svg";